module.exports = __webpack_public_path__ + "img/game.fd3c8efd.svg";